'use strict';

angular.module('docketbook').
  controller('selectRoleController', function(userService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

    // Initialise variables to be used
    $scope.roleSearchLoading = false;
    $scope.rolesSearchList = [];
    $scope.roleSelectCallback = null;
    $scope.desktopSelected = [];

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.roleSelectFromParent = function(existingRoles, cb) {
      $scope.roleSelectCallback = cb;
      $scope.existingRoles = existingRoles;
      $scope.desktopSelected = [];
      $("#selectRoleModal").fadeIn(200);
      $scope.loadRoleList();
    }

    $scope.loadRoleList = function() {
      $scope.promise = $q(function(resolve, reject) {
        userService.getRoles(null, function(returnObject) {
          $scope.rolesSearchList = returnObject;
          for ( var i = 0; i < $scope.rolesSearchList.length; i++ ) {
            if ( $scope.existingRoles && $scope.existingRoles.indexOf($scope.rolesSearchList[i].id) != -1 ) {
              $scope.rolesSearchList[i].assigned = true;
            }
          }
          resolve('Done');
        }, function(err) {
          $scope.rolesSearchList = [];
          reject('Error');
        });
      });
    }

    $scope.closeRoleSelectList = function() {
      $scope.roleSelectCallback(null);
      $("#selectRoleModal").fadeOut(100);
    }

    $scope.desktopSelectRoleContinue = function() {
      $scope.roleSelectCallback($scope.desktopSelected);
      $("#selectRoleModal").fadeOut(100);
    }
});



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectRoleController.js